import { render, staticRenderFns } from "./N8NIcon.vue?vue&type=template&id=3322454a&scoped=true"
import script from "./N8NIcon.vue?vue&type=script&lang=js"
export * from "./N8NIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3322454a",
  null
  
)

export default component.exports